<template>
  <div class="unanswered-header flex-row">
    <span
      v-if="showPosition"
      class="flex-row"
      data-test="position-section"
    >
      <span class="icon-wrapper">
        <icon
          name="hash"
          variant="4B5565"
        ></icon>
      </span>
      <span>{{ sessionProgress }}</span>
    </span>
    <span class="spacer"></span>
    <action-buttons
      :category="category"
      context-type="question"
      :flashcard="flashcard"
    />
  </div>
</template>

<script>
import Icon from '@/components/singletons/icon';
import ActionButtons from '@/components/flashcards-v2/fragments/ActionButtons.vue';
import CurrentFlashcardSessionMixin from '@/mixins/currentFlashcardSession';

export default {
  components: { Icon, ActionButtons },
  mixins: [CurrentFlashcardSessionMixin],
  props: {
    category: {
      type: Object,
    },
    index: {
      type: Number,
      default: -1,
    },
    totalCount: {
      type: Number,
      default: 0,
    },
    flashcard: {
      type: Object,
      default: () => ({}),
    },
    isLearningPath: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    sessionProgress() {
      return `${this.currentPosition.position} of ${this.currentPosition.total}`;
    },
  },
};
</script>

<style lang="scss" scoped>
.flex-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: .25rem;
}
.unanswered-header {
  margin: 1rem;
  gap: 1rem;
  line-height: rem-calc(20);
  font-size: rem-calc(14);
  font-weight: 600;
  color: #697586;

  .spacer {
    flex-grow: 1;
  }

  .icon-wrapper {
    background-color: #EEF2F6;
    border-radius: rem-calc(4);
    height: rem-calc(24);
    width: rem-calc(24);
    display: grid;
    place-items: center;
  }
}

@include breakpoint(desktop) {
  .unanswered-header {
    margin: 2rem;
  }
}

</style>
